/* HILO Design System · small behaviours. Loaded from snippets/hilo-ds.liquid.

   Bottom Nav (sections/hilo-mobile-nav): marks the tab for the current page
   with .is-active and aria-current — brand colour plus the 16×3 indicator,
   styled in hilo-ds-sections.css. The longest matching link wins, so
   /collections/wedding/x lights "Wedding", not "Home". */
(function () {
  function trim(p) {
    while (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
    return p || '/';
  }
  function mark() {
    var items = document.querySelectorAll('.hilo-mnav .hilo-mnav__item');
    if (!items.length) return;
    var path = trim(location.pathname);
    var best = null;
    var bestLen = -1;
    Array.prototype.forEach.call(items, function (a) {
      var href = trim((a.getAttribute('href') || '').split('?')[0].split('#')[0]);
      var match = href === '/' ? path === '/' : (path === href || path.indexOf(href + '/') === 0);
      if (match && href.length > bestLen) { best = a; bestLen = href.length; }
    });
    Array.prototype.forEach.call(items, function (a) {
      var on = a === best;
      a.classList.toggle('is-active', on);
      if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark);
  else mark();
})();